import { render, staticRenderFns } from "./LinkedContent.vue?vue&type=template&id=8a183b54&scoped=true&"
import script from "./LinkedContent.vue?vue&type=script&lang=js&"
export * from "./LinkedContent.vue?vue&type=script&lang=js&"
import style0 from "./LinkedContent.vue?vue&type=style&index=0&id=8a183b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a183b54",
  null
  
)

export default component.exports